import { init as initAnalytics } from "./modules/analytics.js";
import { init as initVideoHero } from "./modules/video-hero.js";
import { init as initImageSlider } from "./modules/image-slider.js";
import { init as initHeroSlider } from "./modules/hero-slider.js";
import { init as initFloorPlanTabs } from "./modules/floor-plan-tabs.js";
import { init as initNewsletter } from "./modules/newsletter.js";
import { init as initContact } from "./modules/contact.js";
import { init as initPhone } from "./modules/phone.js";
import { init as initContactClicks } from "./modules/contact-clicks.js";
import { initLangSwitcher } from "./modules/lang-switcher.js";
import { init as initScrollRows } from "./modules/scroll-row.js";
import { init as initConfigurator } from "./modules/configurator.js";

document.addEventListener("DOMContentLoaded", () => {
  initAnalytics();
  initVideoHero();
  initImageSlider();
  initHeroSlider();
  initFloorPlanTabs();
  initNewsletter();
  initContact();
  initPhone();
  initContactClicks();
  initLangSwitcher();
  initScrollRows();
  initConfigurator();
});
